import React from 'react';

export type LstPeriodView = 'dia' | 'semana' | 'mes';

interface PeriodSwitcherProps {
  value: LstPeriodView;
  onChange: (v: LstPeriodView) => void;
}

const OPTIONS: Array<{ id: LstPeriodView; label: string }> = [
  { id: 'dia', label: 'Dia' },
  { id: 'semana', label: 'Semana' },
  { id: 'mes', label: 'Mês' },
];

/** Seletor compacto de período (segmented control). */
export const PeriodSwitcher: React.FC<PeriodSwitcherProps> = ({ value, onChange }) => (
  <div className="inline-flex overflow-hidden rounded-[5px] border border-slate-200 dark:border-slate-700">
    {OPTIONS.map((opt) => (
      <button
        key={opt.id}
        type="button"
        onClick={() => onChange(opt.id)}
        aria-pressed={value === opt.id}
        className={`px-3 py-1 text-[11px] font-semibold uppercase tracking-wide transition-colors duration-100 ${
          value === opt.id
            ? 'bg-[#2F6FED] text-white'
            : 'bg-white text-slate-500 hover:bg-slate-50 dark:bg-[var(--bg-surface)] dark:text-slate-400 dark:hover:bg-slate-800'
        }`}
      >
        {opt.label}
      </button>
    ))}
  </div>
);

export default PeriodSwitcher;
